import type { FileBlockConfig } from '@lighthouse/core'

export const generateFileBlock = (mainBreakPoint: string): FileBlockConfig => {
    return {
        previewMode: 'preview',
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 300,
                    unit: 'px'
                },
                overflow: 'visible'
            },
            layout: {}
        },
        breakPoints: []
    }
}
